<template>
  <div class="pa-4 h-100">
    <v-container grid-list-xl fluid>
      <v-card class="mb-3">
        <v-card-title>PRM Push Notification Setup</v-card-title>
        <v-card-subtitle>Use this page to (re)start the Google Calendar subscription.</v-card-subtitle>
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="webhookUrl"
                label="Public Webhook URL for your server"
                placeholder="https://your-app-or-ngrok-url.com/api/prm/webhook"
                hint="Must be HTTPS. Use ngrok for local testing."
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn
                :disabled="!webhookUrl.trim().startsWith('https://') || isLoading"
                :loading="isLoading"
                color="primary"
                @click="startSubscription"
              >
                Subscribe (or Renew)
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card v-if="syncResult" :loading="isLoading">
        <v-card-title>Subscription Result</v-card-title>
        <v-card-text>
          <v-alert type="success">
            {{ syncResult.successMessage || 'Successfully subscribed to calendar changes.' }}
          </v-alert>
          <p><strong>Channel ID:</strong> {{ syncResult.channelId || 'N/A' }}</p>
          <p><strong>Expires:</strong> {{ formatExpirationDate(syncResult.expiration) }}</p>
        </v-card-text>
      </v-card>

      <v-overlay :value="isLoading" absolute>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

    </v-container>
  </div>
</template>

<script>
export default {
  name: 'PrmSyncAdmin',
  created () {
    this.loadSubscriptionInfo()
  },
  data () {
    return {
      webhookUrl: '',
      isLoading: false,
      syncResult: null
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    async loadSubscriptionInfo () {
      try {
        if (!this.user || !this.user.token) {
          return
        }
        const response = await this.axios.get('/api/prm/subscription-info', {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        })
        if (response.data) {
          const { webhookUrl, channelId, expiration } = response.data
          if (typeof webhookUrl === 'string') {
            this.webhookUrl = webhookUrl
          }
          if (channelId || expiration) {
            this.syncResult = {
              successMessage: 'Current subscription status.',
              channelId: channelId || 'N/A',
              expiration: expiration || null
            }
          } else {
            this.syncResult = null
          }
        }
      } catch (error) {
        console.error('[PRM Sync] Failed to load subscription info:', error)
      }
    },
    formatExpirationDate (expiration) {
      if (!expiration) {
        return 'N/A'
      }
      const expirationNum = Number(expiration)
      if (isNaN(expirationNum) || expirationNum <= 0) {
        return 'Invalid Date'
      }
      const date = new Date(expirationNum)
      if (isNaN(date.getTime())) {
        return 'Invalid Date'
      }
      return date.toLocaleString()
    },
    startSubscription () {
      if (!confirm('Are you sure? This will stop any existing subscription and create a new one.')) {
        return
      }

      this.isLoading = true
      this.syncResult = null

      const trimmedWebhookUrl = this.webhookUrl.trim()

      this.axios
        .post(
          '/api/prm/subscribe',
          {
            webhookUrl: trimmedWebhookUrl
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.user.token
            }
          }
        )
        .then((response) => {
          this.syncResult = response.data
          this.$store.dispatch('setSuccess', { successMsg: 'Subscription successful!' })
          this.loadSubscriptionInfo()
        })
        .catch((error) => {
          this.$store.dispatch('setError', {
            errorMsg: 'Subscription failed: ' + (error.response?.data || error.message)
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
